var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactsDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.087,
    viewBox: "0 0 18 18.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160662",
    "data-name": "Group 160662",
    transform: "translate(-408.421 -287.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160591",
    "data-name": "Group 160591",
    transform: "translate(408.421 288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    d: "M15.949,16.541a5.048,5.048,0,0,1,.749,2.531,16.124,16.124,0,0,1-12.168,0c.057-2.982,2.761-5.382,6.084-5.382a8.585,8.585,0,0,1,2.574.475",
    transform: "translate(-2.024 -3.751)",
    fill: "#adc7ff",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_963",
    width: 18,
    height: 18,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    d: "M14.387,5.344A3.064,3.064,0,1,1,11.324,2.28h0a3.057,3.057,0,0,1,3.055,3.064Z",
    transform: "translate(-2.731 -1.617)",
    fill: "#f49b31",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_134",
    "data-name": "Ellipse 134",
    cx: 0.467,
    cy: 0.467,
    r: 0.467,
    transform: "translate(12.122 11.054)",
    fill: "#165cf3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsDarkIcon);
export default __webpack_public_path__ + "static/media/contacts-dark-icon.a1521945cd2c20a25ec5758358549eba.svg";
export { ForwardRef as ReactComponent };